import {
  highlightBracketedText,
  highlightUnderscoreText,
} from "src/utils/utils";
import {
  ImageAndTextFieldsFragment,
} from "src/generated/graphql";
import { useLocation } from "react-router-dom";

type AutomaticContentProps = {
  content: ImageAndTextFieldsFragment;
};

const ProductContent = ({ content }: AutomaticContentProps) => {
  const { eyebrowText, title, imageDescriptionJson } = content;
  const bulletPoints =
    imageDescriptionJson?.json?.content
      ?.filter((val) => val.nodeType === "unordered-list")[0]
      ?.content?.map((item) => item?.content[0]?.content[0]?.value) || [];

  const midIndex = Math.ceil(bulletPoints.length / 2);
  const firstColumn = bulletPoints.slice(0, midIndex);
  const secondColumn = bulletPoints.slice(midIndex);
  const location = useLocation();
  const pathParts = location.pathname.toLowerCase().split("/").filter(Boolean);
  const isRouteIndustry= pathParts.length === 1 && pathParts[0] === "industries";
  return (
    <>
      <div className="promise-section">
        <div className="container-fluid custom-spacer-col">
          <div className={`promise-inner-section ${isRouteIndustry && 'promise-inner-section-industry' }`}>
            <div className="promise-left promise-industry">
              <h2
                className="highlight-bracket-text"
                dangerouslySetInnerHTML={{
                  __html: highlightBracketedText(eyebrowText ?? "", "bold"),
                }}
                style={{ textAlign: "start" }}
              />

              <div className="promise-description">
                <p
                  dangerouslySetInnerHTML={{
                    __html: highlightUnderscoreText(title ?? ""),
                  }}
                />
              </div>
            </div>
            <div className="promise-right">
              {/* First Column */}
              <ul className="promise-list">
                {firstColumn.map((point, index) => (
                  <li key={`col1-${index}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M16.909 8.72725L10.3635 15.2727L7.63628 12.5454M16.909 8.72725L10.3635 15.2727M22.909 12C22.909 18.0249 18.0248 22.9091 11.9999 22.9091C5.97499 22.9091 1.09082 18.0249 1.09082 12C1.09082 5.97505 5.97499 1.09088 11.9999 1.09088C18.0248 1.09088 22.909 5.97505 22.909 12Z"
                        stroke="#8773DA"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="#CDCDF3"
                      />
                      <path
                        d="M16.909 8.72729L10.3635 15.2727L7.63623 12.5455"
                        stroke="#8773DA"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>

              {/* Second Column */}
              <ul className="promise-list">
                {secondColumn.map((point, index) => (
                  <li key={`col2-${index}`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M16.909 8.72725L10.3635 15.2727L7.63628 12.5454M16.909 8.72725L10.3635 15.2727M22.909 12C22.909 18.0249 18.0248 22.9091 11.9999 22.9091C5.97499 22.9091 1.09082 18.0249 1.09082 12C1.09082 5.97505 5.97499 1.09088 11.9999 1.09088C18.0248 1.09088 22.909 5.97505 22.909 12Z"
                        stroke="#8773DA"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="#CDCDF3"
                      />
                      <path
                        d="M16.909 8.72729L10.3635 15.2727L7.63623 12.5455"
                        stroke="#8773DA"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductContent;
